export enum OfferTarget {
    All = 0,
    SIC = 1,
    Engage = 2,
}
